/// <amd-module name="Agile/Common/Redux/BacklogConfiguration/BacklogConfigurationContracts" />

export interface IBacklogConfigurationAwareState {
    backlogConfiguration: IBacklogConfiguration;
}

export interface IBacklogConfiguration {
    readonly projectId: string;
    readonly workItemTypeMappedStates: WorkItemTypeStateInfo[];
    readonly backlogFields: IBacklogFields;
    readonly taskBacklog: IBacklogLevelConfiguration;
    readonly requirementBacklog: IBacklogLevelConfiguration;
    readonly portfolioBacklogs: IBacklogLevelConfiguration[];
    readonly hiddenBacklogs: string[];
    readonly teamId: string;
}

export interface IBacklogFields {
    readonly typeFields: { [key: /* BacklogFieldTypes */ number]: string };
}

export interface IBacklogLevelConfiguration {
    readonly id: string;
    readonly name: string;
    readonly rank: number;
    readonly color: string;
    readonly workItemCountLimit: number;
    readonly addPanelFields: string[];
    readonly columnFields: IColumnField[];
    readonly workItemTypes: string[];
    readonly defaultWorkItemType: string;
}

export interface IColumnField {
    readonly columnFieldReference: string;
    readonly width: number;
}

export enum WorkItemStateCategory {
    Proposed = 1000,
    InProgress = 2000,
    Resolved = 3000,
    Completed = 4000,
    Removed = 5000
}

export enum BacklogFieldTypes {
    Effort = 1,
    Order = 2,
    RemainingWork = 3,
    Team = 4,
    Activity = 5,
    Requestor = 6,
    ApplicationType = 7,
    ApplicationStartInformation = 8,
    ApplicationLaunchInstructions = 9,
    FeedbackNotes = 10,
    ClosedDate = 11
}

export type StateToCategoryMap = { [state: string]: WorkItemStateCategory };
export interface WorkItemTypeStateInfo {
    readonly workItemTypeName: string;
    readonly states: StateToCategoryMap;
}
